import {json2csv}  from 'json-2-csv';
import { name as animalName } from './animal';

const isInProgress = (assessment) => {
	return (assessment.started_on && !assessment.submitted_on) ? true : false;
}

const isComplete = (assessment) => {
	return (assessment.started_on && assessment.submitted_on) ? true : false;
}

/*
Returns:
{
	"animal_id": {
		"animal": Object,
		"assessment: Object || null
	}
}
*/
const getAnimalLastAssessments = (animals,assessments) => {
	const animalStatus = animals.reduce((acc,cur)=>{
		acc[cur.id] = {
			assessment: null,
			animal: cur
		};
		return acc;
	},{});

	const animalLastAssessments = assessments.reduce((acc,cur)=>{
		const record = acc[cur.animal_id];
		if (record.assessment === null || cur.started_on > record.assessment.started_on) {
			acc[cur.animal_id].assessment = cur;
		}
		return acc;
	},animalStatus);

	return animalLastAssessments;
}

const otherAnimalsNearby = (animals,filterAnimal) => {
	return animals.filter((cur)=>{
		return cur.id !== filterAnimal.id;
	}).map((cur)=>{
		return {label: animalName(cur), value: cur.id};
	});
}


const assessmentCsvList = ({assessments, animals, users}) => {

	const userName = (id) => {
		const temp = users.find((cur)=>cur.id === id);
		return (temp) ? temp.name : '';
	}

	const animalName = (id) => {
		const temp = animals.find((cur)=>cur.id === id);
		return (temp) ? temp.name : '';
	}


	const assessmentCsv = json2csv(assessments.map((cur)=>{
		const {report_path,report_rnage, report_title, section_a, section_b, section_c, section_c_incidents_of_aggression, sync, ...rest} = cur;
		return {
			...rest,
			animal_name: animalName(rest.animal_id),
			user_name: userName(rest.user_id),
		};
	}));
	console.log(assessmentCsv);

	//const sectionaCsv = json2csv(

	const tempa = assessments.map((cur)=>{
		return cur.section_a || [];
	})
	.reduce((acc,cur)=>{
		acc = acc.concat(cur);
		return acc;
	},[])
	.map((cur)=>{
		const {sync, ...rest} = cur
		return {
			...rest,
			other_animals_nearby: (rest.other_animals_nearby.length > 0) ? rest.other_animals_nearby.join(', ') : '',
			other_animals_nearby_names: rest.other_animals_nearby.map((id)=>(animalName(id))).join(', '),
			user_name: userName(rest.user_id),
		};
	});

	const sectionaCsv = json2csv(tempa);

	const tempb = assessments.map((cur)=>{
		return cur.section_b || [];
	})
	.reduce((acc,cur)=>{
		acc = acc.concat(cur);
		return acc;
	},[])
	.map((cur)=>{
		const {sync,section_b_behaviors,...rest} = cur
		return {
			...rest,
			other_animals_nearby: (rest.other_animals_nearby.length > 0) ? rest.other_animals_nearby.join(', ') : '',
			other_animals_nearby_names: rest.other_animals_nearby.map((id)=>(animalName(id))).join(', '),
			user_name: userName(rest.user_id),
		};
	});

	const sectionbCsv = json2csv(tempb);


	const tempbdetailed = assessments.map((cur)=>{
		return cur.section_b || [];
	})
	.reduce((acc,cur)=>{
		acc = acc.concat(cur);
		return acc;
	},[])
	.map((cur)=>{
		// cur is all the section_b records
		const {section_b_behaviors,assessment_id} = cur

		return (section_b_behaviors || []).map((cur)=>{
			return {...cur,assessment_id};
		});
	})
	.reduce((acc,cur)=>{
		acc = acc.concat(cur);
		return acc;
	},[])
	.map((cur)=>{
		// all section_b_behaviors
		const {sync,...rest} = cur
		return {
			...rest,
			associated_animals: (rest.associated_animals.length > 0) ? rest.associated_animals.join(', ') : '',
			associated_animal_names: rest.associated_animals.map((id)=>(animalName(id))).join(', '),
			tags: (rest.tags && rest.tags.length > 0) ? rest.tags.join(', ') : '',
		};
	})

	const sectionbdetailedCsv = json2csv(tempbdetailed);


	const tempc = assessments.map((cur)=>{
		return cur.section_c || [];
	})
	.reduce((acc,cur)=>{
		acc = acc.concat(cur);
		return acc;
	},[])
	.map((cur)=>{
		const {sync, ...rest} = cur
		return {
			...rest,
			associated_animals: (rest.associated_animals.length > 0) ? rest.associated_animals.join(', ') : '',
			associated_animals_names: rest.associated_animals.map((id)=>(animalName(id))).join(', '),
			user_name: userName(rest.user_id),
		};
	});

	//console.log(tempc);

	const sectioncCsv = json2csv(tempc);

	const fileData = {
		"assessment.csv": new TextEncoder().encode(assessmentCsv),
		"section_a.csv": new TextEncoder().encode(sectionaCsv),
		"section_b.csv": new TextEncoder().encode(sectionbCsv),
		"section_b_behavior.csv": new TextEncoder().encode(sectionbdetailedCsv),
		"section_c.csv": new TextEncoder().encode(sectioncCsv),
	};

	return fileData;
}


export {isInProgress, isComplete, getAnimalLastAssessments, otherAnimalsNearby, assessmentCsvList };
